import { GetSupportTicketsResponse } from "@shared/types/localTypes/supportTickets.ts";
import { DateTime } from "luxon";

import json from "../../json/supportTickets/getSupportTickets.json";

export default async () => {
  const response = JSON.parse(
    JSON.stringify(await json),
  ) as GetSupportTicketsResponse;

  return {
    supportTickets: response.supportTickets.map((ticket, index) => ({
      ...ticket,
      creationDate: DateTime.now()
        .minus({ days: index + 2 })
        .toISO(),
    })),
  } satisfies GetSupportTicketsResponse;
};
